<template>
<div class='slide slide--journal'>
  <div class='slide_label body-four-light'>
    {{ activity.label || $t('journal') }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div
    v-if='activity.subheadline'
    class='slide_subheadline body-one-light'
    v-html='activity.subheadline'
  />

  <button
    class='slide_cta button-one-light'
    @click.prevent='toggleActivityOverlay()'
  >
    {{ activity.cta }}
  </button>
</div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin]
}
</script>

<style lang='sass' scoped>
// @import './journal-v1'
</style>
